import { FunctionComponent } from "react";
import { Label, ListGroupContainer, SubheaderValue, ListValue, TableCheck } from "./styled.components";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { ListSubheader } from '@mui/material'
import { useSelector } from "react-redux";

type ListParamProps = {
    param: any
    groupValues: any
    handleOnCheckAll: (e: any) => void
    handleOnCheckChange: (e: any) => void
}

const ListParam: FunctionComponent<ListParamProps> = ({ param, groupValues, handleOnCheckAll, handleOnCheckChange }) => {

    const { header } = useSelector((state: any) => state.theme);

    const handleRenderListItems = (group: any) => {
        return (group.visible) ?
            (<div className={(group.idGroup) ? "group-list" : ""}>
                {(group.idGroup) ? (
                    <ListSubheader key={`groupList${group.idGroup}`} style={{ width: "100%", fontSize: "0.8em", fontWeight: 700, padding: 0 }}>
                        <SubheaderValue style={{ backgroundColor: header?.gridHeader }}>
                            <label className="inline-text">{group.name}</label>
                        </SubheaderValue>
                    </ListSubheader>
                )
                    : (<></>)}
                {group.values.map((itemList: any) => {
                    return (
                        <ListItem
                            key={`listItem${itemList.idValor}`}
                            style={{ width: "100%", fontSize: "0.8em", }}
                            disablePadding
                        >
                            <ListValue>{itemList.valorDescripcion}</ListValue>
                            <div className={"content-check"}>
                                <TableCheck
                                    color={header?.gridHeader}
                                    onChange={() => handleOnCheckChange(itemList)}
                                    checked={(itemList.segmentado === 1)}
                                />
                            </div>
                        </ListItem>
                    )
                })
                }
            </div>)
            : (<></>)
    }

    return (<ListGroupContainer id={`list${param.idParametro}`} key={`list${param.idParametro}`}>
        <Label>{param.nombreParametro}</Label>
        <List
            dense
            sx={{
                width: '100%',
                maxWidth: 360,
                bgcolor: 'transparent',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 350,
                '& ul': { padding: 0 },
            }}
            subheader={<li />}
        >
            <ListItem
                key={`listItem${-1}`}
                style={{ width: "100%", fontSize: "0.8em", fontWeight: 700 }}
                disablePadding
            >
                <ListValue>{"SELECCIONAR TODOS"}</ListValue>
                <div className={"content-check"}>
                    <TableCheck
                        color={header?.gridHeader}
                        onChange={() => handleOnCheckAll(param)}
                        checked={(param.allChecked)}
                    />
                </div>
            </ListItem>
            {groupValues.map(handleRenderListItems)}
        </List>
    </ListGroupContainer>)
}

export default ListParam;
